// Specializaion
import { subGroup, route, meta } from '@/helpers/routes'
import Index from './index/index'

const routes = [
  route('index', '/index', Index, meta('Termo de uso', true))
]

export default subGroup('/terms', routes)



// WEBPACK FOOTER //
// ./src/app/professional/terms/routes.js